import * as angular from "angular";
import {IController} from "angular";
import {ServiceItem} from "../../models/service-item.model";
import {SplitService} from "../../services/split-service.service";

export class BringozItemsLabelsTotalsComponent implements IController {

  items: ServiceItem[];

  public siteLabelsMap: {} = {};
  public labelsTotalsMap: {};

  constructor(private splitService: SplitService) {
  }

  $onInit() {
    this.splitService.getSiteLabels().map(label => {
      this.siteLabelsMap[label.name] = label;
    });
    this.initTotals();
  }

  $onChanges(changes: angular.IOnChangesObject) {
    if (changes.items && !changes.items.isFirstChange()) {
      this.initTotals();
    }
  }

  private initTotals() {
    this.labelsTotalsMap = {};
    if (!this.items?.length) {
      return;
    }
    this.items.forEach(i => {
      if (!i) {
        return;
      }
      i.labels?.forEach(l => {
        if (!this.labelsTotalsMap[l]) {
          this.labelsTotalsMap[l] = {
            volume: 0,
            weight: 0
          }
        }
        this.labelsTotalsMap[l].weight += i.weight;
        this.labelsTotalsMap[l].volume += i.volume || i.dimensions.cube || 0;
      })
    });
  }
}

angular
  .module('bringoz.admin.commons')
  .component('bringozItemsLabelsTotals', {
    bindings: {
      items: '<'
    },
    template: require('./bringoz-items-labels-totals.html').default,
    controller: BringozItemsLabelsTotalsComponent
  });
